import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Facebook, Instagram, Twitter } from 'lucide-react';

export const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <div className="flex items-center space-x-3 mb-4">
              <img 
                src="https://customer-assets.emergentagent.com/job_explore-skytrips/artifacts/n3t07i35_Sky_Trips_Logo-removebg-preview.png" 
                alt="Sky Trips Logo" 
                className="h-10 w-10 object-contain"
              />
              <div>
                <div className="text-2xl font-bold">
                  <span className="text-sky-400">Sky</span>
                  <span className="text-emerald-400">Trips</span>
                </div>
                <div className="text-xs font-medium text-emerald-400 -mt-1">
                  Discover The World
                </div>
              </div>
            </div>
            <p className="text-gray-300 mb-4">
              Your trusted travel partner for unforgettable journeys across India and around the world.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-gray-300 hover:text-sky-400 transition-colors">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="#" className="text-gray-300 hover:text-sky-400 transition-colors">
                <Instagram className="w-5 h-5" />
              </a>
              <a href="#" className="text-gray-300 hover:text-sky-400 transition-colors">
                <Twitter className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/about" className="text-gray-300 hover:text-sky-400 transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/tours" className="text-gray-300 hover:text-sky-400 transition-colors">
                  Tour Packages
                </Link>
              </li>
              <li>
                <Link to="/tours/domestic" className="text-gray-300 hover:text-sky-400 transition-colors">
                  Domestic Tours
                </Link>
              </li>
              <li>
                <Link to="/tours/international" className="text-gray-300 hover:text-sky-400 transition-colors">
                  International Tours
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-300 hover:text-sky-400 transition-colors">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Tour Categories */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Tour Categories</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/tours/honeymoon" className="text-gray-300 hover:text-sky-400 transition-colors">
                  Honeymoon Packages
                </Link>
              </li>
              <li>
                <Link to="/tours/group" className="text-gray-300 hover:text-sky-400 transition-colors">
                  Group Tours
                </Link>
              </li>
              <li>
                <Link to="/tours/pilgrim" className="text-gray-300 hover:text-sky-400 transition-colors">
                  Pilgrim Tours
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Contact Us</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <MapPin className="w-5 h-5 text-sky-400 flex-shrink-0 mt-1" />
                <span className="text-gray-300 text-sm">
                  Office No. 1, Gulmohar CHS, Bldg No. A4,<br />
                  Raigad Ali Road, Panchpakhadi,<br />
                  Thane (West) – 400602, Maharashtra
                </span>
              </li>
              <li className="flex items-center space-x-3">
                <Phone className="w-5 h-5 text-sky-400" />
                <div className="text-gray-300 text-sm">
                  <a href="tel:+919833280079" className="hover:text-sky-400 transition-colors">
                    +91 9833280079
                  </a>
                  <br />
                  <a href="tel:+919920995700" className="hover:text-sky-400 transition-colors">
                    +91 9920995700
                  </a>
                </div>
              </li>
              <li className="flex items-center space-x-3">
                <Mail className="w-5 h-5 text-sky-400" />
                <a href="mailto:info@skytrips.world" className="text-gray-300 text-sm hover:text-sky-400 transition-colors">
                  info@skytrips.world
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 text-center">
          <p className="text-gray-400 text-sm">
            © {new Date().getFullYear()} Sky Trips. All rights reserved. | Designed with ❤️ for travelers
          </p>
        </div>
      </div>
    </footer>
  );
};